import RotatableImage from './_rotatable-image.js'
import FlexPane from './_flex-pane.js'
import HideablePane from './_hideable-pane.js'
import Button from './_button.js'
import Text from './_text.js'
import Spinner from './_spinner.js'
import Image from './_image.js'

export default {
  name: 'ExpandableView',
  values: {
    rotation: {
      configSet: RotatableImage,
      configValues: {
        image: {
          src: 'chevron-up',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          flexDirection: 'column',
        },
      },
    },
    contentContainer: {
      configSet: HideablePane,
      configValues: {
        style: {
          innerContainer: {
            flexDirection: 'column',
          },
        },
      },
    },
    headerContainer: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            alignItems: 'center',
            minHeight: '35px',
            padding: '0 8px',
            gap: '8px',
          },
        },
      },
    },
    headerTextContainer: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 1,
        },
        style: {
          color: 'black',
          fontSize: '14px',
        },
      },
    },
    leftItemsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexGrow: 0,
        },
      },
    },
    rightItemsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexGrow: 0,
        },
      },
    },
    expandIconPosition: 'left',
    initiallyExpanded: false,
    showLoadingSpinner: true,
    loadingSpinner: {
      configSet: Spinner,
      configValues: {
        style: {
          container: {
            height: '8px',
            width: '8px',
          },
        },
      },
    },
    leftIcon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
